import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import template from './plantDashboard.tpl.html';
import {Plant} from "../../models/navigation";
import DateUtilityService from "../../services/utility/dateutility.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import DateServiceName, {DateService} from "../../services/utility/date.service";
import {TopDefectsHub, TopDefectsHubCreator} from "../../services/reports/topDefects.hub";
import ViewDefectName, {openViewDefect} from "../defects/viewDefect.controller";
import {States} from "../../shared/config/constant.module";

let requires = [ReportServiceName, LoaderServiceName, NavigationServiceName, DateServiceName, ViewDefectName];

class PlantDashboardCtrl {

  plant: Plant;
  dateService: DateService;
  reportService: ReportService;
  navigationService: NavigationService;
  loaderService: LoaderService;
  $modal: mm.foundation.modal;
  packEfficiency: apsEnums.WellKnownCheckType;
  criticalDefects: apsViewModels.CriticalDefectReportItem[];
  criticalDefectsLoaded: boolean;

  queryStartUTC: Date;
  queryEndUTC: Date;

  private hubs: TopDefectsHub[];
  private $scope: angular.IScope;
  private $timeout: angular.ITimeoutService;
  private topDefectsHubCreator: TopDefectsHubCreator;

  constructor(navigationService: NavigationService,
              loaderService: LoaderService,
              dateService: DateService,
              reportService: ReportService,
              topDefectsHubCreator: TopDefectsHubCreator,
              $scope: angular.IScope,
              $timeout: angular.ITimeoutService,
              $modal: mm.foundation.modal) {
    this.packEfficiency = apsEnums.WellKnownCheckType.ShopPackEfficiency;
    this.reportService = reportService;
    this.dateService = dateService;
    this.loaderService = loaderService;
    this.navigationService = navigationService;
    this.$modal = $modal;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.topDefectsHubCreator = topDefectsHubCreator;
    this.criticalDefectsLoaded = false;

    this.loadData();

    this.hubs = [];

    this.$scope.$on('$destroy', () => {
      _.forEach(this.hubs, hub => hub.uninitialize());
      this.hubs = [];
    });
  }

  private onDefectAdded(defect: apsViewModels.TopDefectEvent) {
    if (!this.criticalDefects
        || defect.severity !== apsEnums.Severity.Critical
        || this.queryStartUTC.getTime() > defect.timeFound.getTime()) {
      return;
    }

    var shop = _.find(this.plant.shops, {id: defect.shopId});
    if (!shop) {
      return;
    }

    this.$timeout(() => {
      this.criticalDefects.push(<apsViewModels.CriticalDefectReportItem>_.assign({shopName: shop.name}, defect));
    });
  }

  private onDefectRemoved(defect: apsViewModels.TopDefectEvent) {
    if (!this.criticalDefects
      || defect.severity !== apsEnums.Severity.Critical
      || this.queryStartUTC.getTime() > defect.timeFound.getTime()) {
      return;
    }

    var existing = _.find(this.criticalDefects, {id: defect.id});
    if (!existing) {
      return;
    }

    this.$timeout(() => {
      _.remove(this.criticalDefects, existing);
    });
  }

  loadData(): void {

    var loadPromise = this.navigationService.getNavigation()
      .then((navModel) => {
        var end = this.dateService.now();
        var start = moment(end).subtract(24, 'hours').toDate();

        var timeZoneId = navModel.selectedPlant.timeZoneId;
        this.queryEndUTC = DateUtilityService.localToTimeZoneWithSeconds(end, timeZoneId).toDate();
        this.queryStartUTC = DateUtilityService.localToTimeZoneWithSeconds(start, timeZoneId).toDate();

        this.plant = navModel.selectedPlant;

        _.forEach(this.plant.shops, shop => {
          this.hubs.push(this.topDefectsHubCreator.createTopDefectsHub(shop.id,
            d => this.onDefectAdded(d),
            d => this.onDefectRemoved(d)
          ));
        });
      })
      .then(() => {
        this.reportService.getCriticalDefectsReport(this.plant.id, this.queryStartUTC).then((results) => {
          this.criticalDefects = results;
          this.criticalDefectsLoaded = true;
        });
      });

    this.loaderService.loadingPromise(loadPromise);
  }

  formatTimeOnly(time: Date): string {
    return DateUtilityService.formatTimeOnly(time, this.plant.timeZoneId);
  }

  viewDefect(defectId: string): void {
    openViewDefect({
      defectId: defectId,
      readOnly: true,
      gob: null,
      canComment: null,
      defect: null,
      plantId: null
    }, this.$modal);
  }
}

export default angular.module('aps.controller.plantDashboard', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.PLANT_DASHBOARD,
      url: '/plant/dashboard',
      controller: 'PlantDashboardCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Plant Snapshot',
        allowPlantLevel: true,
        v2Uri: "aps/dashboard/plant/plant-dashboard",
      }
    });
  })
  .controller('PlantDashboardCtrl', PlantDashboardCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/plantDashboard.controller.ts